/** @format — The customer's own view (29 Oct), shown only when REACT_APP_CUSTOMER_VIEW is on. */

import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../components/Layout";
import { MyCar, MyCars } from "../pages/customer/MyCars";
import MyDecisions from "../pages/customer/MyDecisions";
import MyContainers from "../pages/customer/MyContainers";
import NextContainers from "../pages/customer/NextContainers";
import PurchaseDetails from "../pages/customer/PurchaseDetails";
import OfferContainer from "../pages/vendors/OfferContainer";
import MyDockie from "../pages/customer/MyDockie";
import MyTeam from "../pages/customer/MyTeam";
import { MyDocuments, MyInvoices } from "../pages/customer/MyInvoices";
import { CUSTOMER_VIEW_ON, useMyAccount } from "@/services/python-api/customerHooks";

const PAGES = {
  cars: "Your cars",
  decisions: "Needs your decision",
  invoices: "Invoices",
  papers: "Papers",
  team: "Team",
  dockie: "Ask Dockie",
  containers: "Containers",
  next: "Next containers",
  purchase: "Purchase details",
  offers: "Offer a container",
};
// A partner the team invited sees cars, papers, containers and its own Dockie only.
const PARTNER_PAGES = new Set(["cars", "papers", "dockie", "containers", "offers"]);

export default function CustomerRoute({ page, userName }) {
  const { data: account, isFetched } = useMyAccount();
  if (!CUSTOMER_VIEW_ON) return <Navigate to="/home" replace />;
  // A login that acts for no customer (or a stale one after a reseed): sign in again.
  // No customer for this login: back home. A stale session was already signed out by
  // useMyAccount, so the route guard takes it to sign-in.
  if (isFetched && !account) return <Navigate to="/home" replace />;
  if (account?.partner && !PARTNER_PAGES.has(page)) return <Navigate to="/my-cars" replace />;
  return (
    <Layout title={PAGES[page]} userName={userName}>
      {page === "cars" ? (
        <Routes>
          <Route index element={<MyCars />} />
          <Route path=":last6" element={<MyCar />} />
        </Routes>
      ) : page === "decisions" ? (
        <MyDecisions />
      ) : page === "team" ? (
        <MyTeam />
      ) : page === "next" ? (
        <NextContainers />
      ) : page === "purchase" ? (
        <PurchaseDetails />
      ) : page === "offers" ? (
        <OfferContainer />
      ) : page === "containers" ? (
        <MyContainers />
      ) : page === "dockie" ? (
        <MyDockie />
      ) : page === "invoices" ? (
        <MyInvoices />
      ) : (
        <MyDocuments />
      )}
    </Layout>
  );
}
